import React, {Component} from 'react'
import PropTypes from 'prop-types'
import humanizeTime from '../../../helpers/time/humanizeTime'
import {Alert, Button, Divider, message, notification, Typography} from 'antd'
import markLabelShipped from './actions/markLabelShipped'
import updateLabelNote from './actions/updateLabelNote'

const {Paragraph} = Typography

class OrderLabelDetail extends Component {
    state = {
        loading: false,
        note: this.props.label.note || '',
        error: '',
    }

    componentDidMount() {
        window.addEventListener('keydown', this._handleEnter)
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this._handleEnter)
    }

    _handleEnter = (e) => {
        if (e.key === 'Enter') {
            this._rqMarkLabelShipped(e.target.tagName)
        }
    }

    _handleClick = e => {
        e.preventDefault()

        this._rqMarkLabelShipped(e.target.id)
    }

    _rqMarkLabelShipped = (target) => {
        const {label} = this.props

        if (!['BODY', 'btnMarkShipped'].includes(target) || this.state.loading || !label.printable_url) {
            return
        }

        this.setState({
            loading: true,
        })

        const {onClearInput} = this.props

        markLabelShipped(label._id).then(result => {
            if (result !== true) {
                throw new Error('Something wrong')
            }

            this.setState({
                loading: false,
            })

            message.success('Đánh dấu đã in thành công')

            onClearInput()
        }).catch(err => {
            this.setState({
                error: err.message,
                loading: false,
            })
        })
    }

    _handleChangeNote = value => {
        const {label} = this.props
        const {_id} = label
        const {note} = this.state

        if (note === value) {
            return
        }

        updateLabelNote(_id, value).then(result => {
            if (result !== true) throw new Error('Something wrong')

            message.success('Đã lưu note')

            this.setState({
                note: value,
            })
        }).catch(err => {
            notification.error({
                message: 'ERROR',
                description: err.message,
                duration: 0,
            })
        })
    }

    render() {
        const {label} = this.props

        const {printable_url, tracking_carrier, tracking_number, type, created_at, barcode} = label
        const {error, loading, note} = this.state

        return (
            <div className='OrderLabelDetail'>
                <Divider orientation='left'><h2>Thông tin nhãn</h2></Divider>

                {
                    error &&
                    <Alert message='ERROR:' description={error} type='error' showIcon className='mb-3'/>
                }

                <div className='row Huge'>
                    <div className='col-4'>
                        <div className='bg-light p-4'>
                            {
                                !!printable_url ?
                                    <img src={printable_url} alt='Label preview'/>
                                    : <div className="alert alert-danger">Chưa có label</div>
                            }
                        </div>
                    </div>

                    <div className='col-7 ml-auto'>
                        <div className='row mb-3'>
                            <div className='col-4'>Mã đơn</div>
                            <div className='col-8'><h4>#{barcode}</h4></div>
                        </div>

                        <div className='row mb-3'>
                            <div className='col-4'>Tracking number</div>
                            <div className='col-8'><h4>{tracking_number}</h4></div>
                        </div>

                        <div className='row mb-3 Note'>
                            <div className='col-4'>Note</div>
                            <div className='col-8 Content'>
                                <Paragraph editable={{onChange: this._handleChangeNote}}>{note}</Paragraph>
                            </div>
                        </div>

                        <div className='row mb-3'>
                            <div className='col-4'>Tracking carrier</div>
                            <div className='col-8'>{tracking_carrier}</div>
                        </div>

                        <div className='row mb-3'>
                            <div className='col-4'>Loại</div>
                            <div className='col-8'>{type}</div>
                        </div>

                        <div className='row mb-3'>
                            <div className='col-4'>Ngày tạo</div>
                            <div className='col-8'>{humanizeTime(created_at)}</div>
                        </div>

                        <Button type='primary' block size='large' onClick={this._handleClick}
                                disabled={loading || !printable_url}
                                id='btnMarkShipped'>Đóng gói xong</Button>
                    </div>
                </div>
            </div>
        )
    }
}

OrderLabelDetail.propTypes = {
    label: PropTypes.object.isRequired,
    onClearInput: PropTypes.func.isRequired,
}

export default OrderLabelDetail
